import { useEffect } from 'react';
import { useParams, Link  } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetInsuranceDetailsQuery } from '../slices/insurancesApiSlice';

const InsuranceScreen = () => {
  const { id: insuranceId } = useParams();

  const { data: insurance, refetch, isLoading, error } = useGetInsuranceDetailsQuery(insuranceId);

  useEffect(() => {
    if (!insurance) {
      refetch();
    }
  }, [insurance, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>Insurance {insurance?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
                      
              <h2>Customer Details</h2>
              <Message>
              Your cart is empty <Link to="/house/HomeScreen">Go Back</Link>
              </Message>
              <p>
                <strong>Name: </strong> {insurance?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {insurance?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {insurance?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {insurance?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {insurance?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Insurance Note</h2>
              <p>{insurance?.note || 'No additional notes provided'}</p>
              <p>{insurance?.username || 'No user name provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Insurance Items</h2>
              {insurance?.insuranceItems?.length === 0 ? (
                <Message>This insurance has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {insurance?.insuranceItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = $
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                        <Col md={4}>
                          {((item?.qty || 0) * (item?.price || 0) * 1.4).toFixed(0)}
                          
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>Insurance Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{insurance?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>TotalRev</Col>
                  <Col>${insurance?.totalPrice || 0}</Col>
                </Row>
                <Row>
                  <Col>TotalInsu</Col>
                  <Col>${(insurance?.totalInsu || 0).toFixed(0)}</Col>
                </Row>

              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{insurance?.status || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default InsuranceScreen;